import React, { forwardRef } from "react";
import Columns from "shared/ui/blocks/columns";
import { BUTTON_VARIANTS, FakeButton } from "shared/ui/button";
import { colors } from "shared/ui/colors";
import { Gap } from "shared/ui/gap";
import { H3, H6 } from "shared/ui/headings";
import ImageLoader from "shared/ui/image-loader";
import { useSiteAreaContext } from "../../../../shared/context/site-area";
import { useTranslationsArray } from '../../../../shared/context/translations';
import { sendTalkToSalesEvent } from "../../../../shared/events/talk-to-sales";
import MultimediaNoOverlap from "../../../../shared/ui/blocks/multimedia-no-overlap";
import { PageSection, TextHolder } from "../styled";
import { useBreakpoints } from "../../../../shared/hooks/use-breakpoints";
import Link from "../../../../../vicoustic/client/commons/link";

const LookCloser = (props, ref) => {
  const { siteArea } = useSiteAreaContext()
  const { isMobile } = useBreakpoints();

  const { t, tA } = useTranslationsArray(`homepageSections.${siteArea}.lookCloser`)

  return (
    <PageSection $siteArea={siteArea} $noPadding ref={ref}>
      <MultimediaNoOverlap $align="flex-end">
        <ImageLoader
          ratio={"1920:1080"}
          viewports={{
            m: t('imageDesktop.src'),
            xs: t('imageMobile.src'),
          }}
          viewportsRatio={{
            m: "1920:1080",
            xs: "16:9",
          }}
        />
        <TextHolder
          style={{
            maxWidth: isMobile ? '100%' : "600px",
            marginBottom: '25px',
            color: colors.white,
            padding: '30px 30px 18px',
            background: `${colors.secondary[siteArea]}${isMobile ? '' : 'cc'}`,
          }}
        >
          <H3 $bold as="h1">
            {t('title')}
          </H3>
          <Gap />
          <H6 $light>{t('subTitle')}</H6>
          <Gap />
          <Columns
            $wrap
            $noCellPadding
            $keepColumnSize
            $horizontalAlignment={"center"}
          >
            {tA('buttons').map(button => (
              <div style={{ margin: '0 6px 12px 6px' }}>
                <Link to={button.link}>
                  <FakeButton
                    style={{ minWidth: '206px' }}
                    $withHover
                    $noWrap
                    variant={BUTTON_VARIANTS.FILLED}
                    >
                    {button.text}
                  </FakeButton>
                </Link>
              </div>
            ))}
            <div style={{ margin: '0 6px 12px 6px' }}>
              <a onClick={sendTalkToSalesEvent} href={t('talkToSalesButton.link')} target="_blank">
                <FakeButton
                  style={{ minWidth: '206px' }}
                  $withHover
                  variant={BUTTON_VARIANTS.FILLED}
                >
                  {t('talkToSalesButton.text')}
                </FakeButton>
              </a>
            </div>
          </Columns>
        </TextHolder>
      </MultimediaNoOverlap>
    </PageSection>
  );
};

export default forwardRef(LookCloser);
